import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useOptionalTravelTranslation } from '../app/TravelLocaleContext';
import { useAuth } from '../auth/AuthContext';
import { authReturnLocation } from '../auth/authReturn';
import { isOfflineCachedAllowedPath } from '../features/offline/offlineConstants';

/**
 * AUTH57 Slice A: offline_cached may reach Overview/Today shell only.
 * Does not unlock Planning / Stays / Transport / collab / other protected children.
 * Page-level offline snapshot rendering remains Slice B.
 */
export default function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();
  const locale = useOptionalTravelTranslation();
  // 有 LocaleProvider 時走 i18n；測試／邊界無 Provider 時不拋錯、不閃 Guest。
  const checkingSession = locale?.t('travel.nav.checkingSession') || '正在確認登入狀態…';

  if (status === 'unknown') {
    return (
      <main className="travel-route-loading" aria-live="polite" data-testid="route-auth-pending">
        <p>{checkingSession}</p>
      </main>
    );
  }

  if (status === 'authenticated') {
    return <Outlet />;
  }

  if (status === 'offline_cached') {
    if (isOfflineCachedAllowedPath(location.pathname)) {
      return <Outlet />;
    }
    return <Navigate to="/login" replace state={{ from: authReturnLocation(location) }} />;
  }

  return <Navigate to="/login" replace state={{ from: authReturnLocation(location) }} />;
}
